import React from 'react';
import {Modal} from '@snsw-gel/react';
import {LinkedAccount} from '../../context/ApplicationContext';

interface RemoveTollAccountConfirmationModalProps {
    readonly tollAccount: LinkedAccount;
    readonly onUnlink: () => void;
    readonly onCancel: () => void;
}

/**
 * A modal for confirming with the user to unlink an account.
 */
const RemoveTollAccountConfirmationModal: React.FC<RemoveTollAccountConfirmationModalProps> = (
    {
        tollAccount,
        onUnlink,
        onCancel,
    }
) => {
    return <Modal
        title={`Remove ${tollAccount.tollProvider} account ${tollAccount.tollAccountNumber}?`}
        description="You won't be able to claim a rebate or check toll spend after you remove this toll account."
        buttons={[
            {text: 'Remove account', onClick: onUnlink},
            {text: 'Cancel', onClick: onCancel},
        ]}
    />;
};

export default RemoveTollAccountConfirmationModal;
